import { render, staticRenderFns } from "./details.vue?vue&type=template&id=dd8bdfda&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=dd8bdfda&prod&lang=css&"
import style1 from "./details.vue?vue&type=style&index=1&id=dd8bdfda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8bdfda",
  null
  
)

export default component.exports